var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('div',{staticClass:"container mt-1"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }